import { Icon } from 'FrontRoyalIcon';
import { memo, type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

function MessageBubbleWithLogoComponent({
    logoSrc,
    altText,
    children,
    dismissable = true,
    textBubbleShown,
    onDismiss,
    renderAfterBubble,
}: {
    logoSrc: string | null;
    altText: string;
    children: ReactNode;
    dismissable?: boolean;
    textBubbleShown: boolean;
    onDismiss?: () => void;
    renderAfterBubble?: () => ReactNode;
}) {
    return (
        <div className="flex flex-row items-end">
            {logoSrc && (
                <div className="mr-3.5 shrink-0">
                    <img className="h-[45px]" src={logoSrc} alt={`${altText} logo`} />
                </div>
            )}

            <div
                className={twMerge(
                    'relative rounded-r-6 rounded-t-6 border-slate-grey-200 bg-white',
                    textBubbleShown ? 'w-full grow border p-[15px] opacity-100' : 'h-0 w-0 opacity-0',
                    textBubbleShown && dismissable ? 'pe-[45px]' : '',
                    'transition-opacity duration-300 ease-in-out',
                )}
            >
                {children}

                {/* Dismiss button */}
                {dismissable && (
                    <button
                        type="button"
                        className="absolute right-0 top-0 p-[15px] text-slate-grey hover:text-black"
                        onClick={onDismiss}
                    >
                        <Icon iconName="Close16" />
                    </button>
                )}

                {/* Text bubble arrow */}
                <div className="absolute bottom-[-1px] left-[-11px] h-0 w-0 border-b-[11px] border-l-[11px] border-b-slate-grey-200 border-l-transparent">
                    <div className="absolute bottom-[-10px] left-[-9px] h-0 w-0 border-b-[9px] border-l-[9px] border-b-white border-l-transparent" />
                </div>
            </div>

            {renderAfterBubble?.() ?? null}
        </div>
    );
}

export const MessageBubbleWithLogo = memo(MessageBubbleWithLogoComponent) as typeof MessageBubbleWithLogoComponent;
